"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_query_1 = require("react-query");
var fetch_user_geolocation_1 = require("../../../utils/fetch-user-geolocation");
var format_price_1 = __importDefault(require("../../../utils/format-price"));
var add_on_filters_1 = require("../add-on-filters");
var app_1 = require("../app");
var email_before_freebie_1 = require("../components/email-before-freebie");
var nav_1 = __importDefault(require("../components/nav"));
var page_1 = __importDefault(require("../components/page"));
var variant_details_modal_1 = __importDefault(require("../components/variant-details-modal"));
var variant_quantity_picker_1 = __importDefault(require("../components/variant-quantity-picker"));
var select_discount_add_ons_1 = require("./select-discount-add-ons");
var useContext = React.useContext, useEffect = React.useEffect, useState = React.useState, useMemo = React.useMemo;
var SelectAddOns = function (_a) {
    var _b;
    var addOns = _a.addOns, numAddOns = _a.numAddOns, settings = _a.settings;
    if (!addOns)
        return null;
    var context = useContext(app_1.AppContext);
    if (!context)
        return null;
    var selAddOns = context.selAddOns, shouldHideLowStockItems = context.shouldHideLowStockItems, handleIncreaseAddOnClick = context.handleIncreaseAddOnClick, handleDecreaseAddOnClick = context.handleDecreaseAddOnClick, isTestingExpandedMobileLayout = context.isTestingExpandedMobileLayout, handleExpandedMobileLayoutSetup = context.handleExpandedMobileLayoutSetup, collectedEmail = context.collectedEmail, isEmailBeforeFreebieTest = context.isEmailBeforeFreebieTest, setCollectedEmail = context.setCollectedEmail;
    useEffect(function () {
        var _a;
        if (isTestingExpandedMobileLayout) {
            handleExpandedMobileLayoutSetup();
        }
        (_a = window.dataLayer) === null || _a === void 0 ? void 0 : _a.push({ event: 'diaperBundle__selectFreebies' });
    }, []);
    var _c = __read(useState(null), 2), openModalProductVariant = _c[0], setOpenModalProductVariant = _c[1];
    var handleOpenModalClick = function (_a) {
        var product = _a.product, variant = _a.variant;
        return function () {
            return setOpenModalProductVariant([product, variant]);
        };
    };
    var handleCloseModalClick = function () { return setOpenModalProductVariant(null); };
    // Determine the customer's country and use it to hide products that are unavailable in their region. We don't check the country of the `existingBundle`'s address like we do
    // in select-discount-add-ons because customers can't add add-ons when updating their bundle, so we'll never have an `existingBundle` on this step.
    var userGeolocationQuery = (0, react_query_1.useQuery)([fetch_user_geolocation_1.getOrFetchAndUpdateCountryCodeByIpCookieUseQueryKey], fetch_user_geolocation_1.getOrFetchAndUpdateCountryCodeByIpCookie);
    var availableAddOns = useMemo(function () {
        if (!userGeolocationQuery.isSuccess)
            return [];
        return addOns.filter((0, select_discount_add_ons_1.addOnsFilterFn)({ shouldHideLowStockItems: shouldHideLowStockItems, userCountryCode: userGeolocationQuery.data.countryCode }));
    }, [userGeolocationQuery.isSuccess, (_b = userGeolocationQuery.data) === null || _b === void 0 ? void 0 : _b.countryCode, addOns, shouldHideLowStockItems]);
    var _d = (0, add_on_filters_1.initFilters)(availableAddOns), filteredAddOns = _d.filteredAddOns, renderFilters = _d.renderFilters, activeFilters = _d.activeFilters;
    var sortedAddOns = useMemo(function () {
        var selAddOnsIds = selAddOns.map(function (v) { return v.id; });
        return filteredAddOns.sort((0, select_discount_add_ons_1.addOnsSortFn)({ selIds: selAddOnsIds }));
    }, [activeFilters, filteredAddOns]);
    var canGoNext = isEmailBeforeFreebieTest ? true : selAddOns.length > 0;
    var shouldShowEmailBeforeFreebie = isEmailBeforeFreebieTest && !collectedEmail;
    return (React.createElement(page_1.default, { renderNav: React.createElement(nav_1.default, { canGoNext: canGoNext, centerContent: React.createElement(React.Fragment, null) }) }, shouldShowEmailBeforeFreebie ? (React.createElement(email_before_freebie_1.EmailBeforeFreebie, { setCollectedEmail: setCollectedEmail, onSubmitGaEventName: 'diaperBundle__emailB4FreebieCollected' })) : (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'padding-6 medium-padding-10 large-padding-horizontal-14 large-padding-vertical-8' },
            React.createElement("h1", { className: 'h3' }, settings.header),
            React.createElement("div", { className: 'margin-bottom-6 font-lighter' }, settings.subheader),
            renderFilters(),
            React.createElement("div", { className: 'grid-x grid-margin-x grid-margin-y' }, sortedAddOns.map(function (_a) {
                var _b = __read(_a, 2), product = _b[0], variant = _b[1];
                return (React.createElement("div", { className: 'cell small-6 medium-4', key: variant.id },
                    React.createElement(variant_quantity_picker_1.default, { priceLine: (0, format_price_1.default)(variant.price), compareAtPrice: variant.compare_at_price ? (0, format_price_1.default)(variant.compare_at_price) : undefined, isSingleSelection: numAddOns === 1, product: product, variant: variant, setModalChoice: handleOpenModalClick({ product: product, variant: variant }), enableDetailsModal: settings.enableDetailsModal, numSelected: selAddOns.filter(function (_a) {
                            var id = _a.id;
                            return id === variant.id;
                        }).length, handleIncClick: handleIncreaseAddOnClick, handleDecClick: handleDecreaseAddOnClick })));
            }))),
        openModalProductVariant && (React.createElement(variant_details_modal_1.default, { productVariantArr: openModalProductVariant, handleCloseModalClick: handleCloseModalClick, isDiscount: false, handleIncreaseClick: handleIncreaseAddOnClick }))))));
};
exports.default = SelectAddOns;
